import { Observable, map } from "rxjs";
import { TRoleProductLine } from "@zaeper/core-lib";
import { ISessionStateService } from "./i-session-state.service";
import { ILicense } from "../../models/i-license";

/** The product lines the active company uses, for the role comparison: signage always, the registry once bought. */
export function roleProductLines$( sessionStateService: ISessionStateService ): Observable<TRoleProductLine[]> {
	return sessionStateService.activeLicense$.pipe( map( ( license: ILicense | null ) =>
		license?.enabledFeatureIds?.includes( "private-repository" ) ? [ "signage", "registry" ] : [ "signage" ] ) );
}
